import React from "react";

const SelectDocument = ({
  id_R,
  closeSelectDoc,
  isSelectDocumentOpen,
  docSelected,
  setDocSelected,
  ContinueSelectDoc,
}) => {
  return (
    <>
      <div
        id={id_R}
        className={`${
          isSelectDocumentOpen ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="relative flex fixed min-h-[90%] w-[62%]">
          <div className="relative flex bg-white shadow w-full mx-auto">
            <div className="w-full flex flex-col mx-5">
              <div className="flex items-center justify-end">
                <button
                  onClick={closeSelectDoc}
                  type="button"
                  className="bg-transparent  rounded-lg text-sm p-1.5 ml-auto inline-flex items-center "
                  data-modal-toggle={id_R}
                >
                  <svg
                    width="61"
                    height="43"
                    viewBox="0 0 61 43"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_13891_3896)">
                      <path
                        d="M32.84 28L30.7 24.9L28.9 28H25.2L28.88 22.3L25.1 16.84H28.94L31.08 19.92L32.88 16.84H36.58L32.84 22.46L36.68 28H32.84Z"
                        fill="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_13891_3896">
                        <rect width="61" height="43" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <span className="sr-only">Close modal</span>
                </button>
              </div>
              <div>
                <div className="mt-5 mx-auto items-center">
                  <p className="text-[#000000] text-[20px] font-bold">
                    Upload Document
                  </p>
                  <div className="text-[#000000] mt-2 text-[15px] font-[300]">
                    <p>
                      Choose which document you wish to upload for the member.
                    </p>
                  </div>
                </div>
                <div className="flex w-full justify-center mt-[20px] mr-4">
                  <div className="flex w-[50%] flex-col justify-center">
                    <label
                      htmlFor="county"
                      className="mb-1 text-md font-normal text-[#000]"
                    >
                      Select document
                    </label>
                    <select
                      name="Idtype"
                      id="Idtype"
                      value={docSelected}
                      onChange={(e) => setDocSelected(e.target.value)}
                      className="w-[90%] bg-[#EAEAEA] h-10 px-4 border-[1px] rounded-[4px] border-[#EAEAEA]"
                    >
                      <option value="National_ID">National ID</option>
                      <option value="Selfie">Selfie</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="flex w-[95%] items-end justify-end h-[56%] mb-7 mr-5">
                <button
                  onClick={ContinueSelectDoc}
                  data-modal-toggle={id_R}
                  type="button"
                  className="text-white hover:bg-[#074073] focus:outline-none font-medium rounded-[5px] text-sm px-8 py-2.5 text-center  bg-[#074073]"
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SelectDocument;
